module.exports = __webpack_public_path__ + "img/python.f3a287da.png";